import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import {Observable} from 'rxjs';
import {Store} from '@ngrx/store';
import {getCoreState} from '@core/store';
import {Customer} from '@core/models';

const pagesAccess: { pageName: string; userTypeId: number[] }[] = [
  { pageName: 'coupons', userTypeId: [1,2,4,5,6,7,8] }, // only 3 branch admin
  { pageName: 'account', userTypeId: [5] },
  { pageName: 'notifications', userTypeId: [5] },
  //{ pageName: 'wish-list', userTypeId: [2, 3] },
  { pageName: 'orders', userTypeId: [5] },
];
@Injectable({
  providedIn: 'root',
})
export class PagesGuard
  
{
  private customer: Customer | undefined;
  constructor(private readonly store: Store, private router: Router) {
    store
      .select(getCoreState)
      .subscribe(
        (state) => (this.customer = state.login?.authorization?.Customer)
      );
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const pageName = route.data['name'];
    //console.log("this.customer?.UserType:" + this.customer?.UserType);

    const restrictedPage = pagesAccess.find((p) => p.pageName === pageName);
    if (restrictedPage) {
      if (!restrictedPage.userTypeId.includes(this.customer?.UserType ?? 0)) { // not 5 guest
        return true;
      } else {
        this.router.navigate(['/']).then();
        return false;
      }
    }
    return true;
  }
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return true;
  }
  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return true;
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    console.log(segments, route.path);
    return true;
  }

  canMatch(
    route: Route,
    segments: UrlSegment[]
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    console.log(segments);
    return false;
  }
}
